/*
  Cart quantities that always show what the cart holds — drawer and cart page.

  Dawn's cart.js changes a line by its POSITION ("line 2 → 4"). On this store that position
  moves under the shopper's finger: the free-gift sync puts its gift line at the top of the
  cart, and Shopify splits one piece into two lines when a discount settles on part of its
  quantity (4 became 1 + 3, each with a new key). A "+" tapped on a drawer drawn a moment
  earlier then landed on the wrong line, or on a line that no longer existed, and the screen
  showed something other than the cart until a reload.

  So here every change:
  - names the PIECE (its variant and properties), not a position, and sets the piece's TOTAL
    quantity — the cart is read fresh just before, so splits and gifts cannot mislead it;
  - waits its turn: one cart write at a time, the gift sync included (window.kkCart.queue);
  - answers with the drawer, the bag count and the cart page drawn from that same reply.
  Taps made while a write is under way are not blocked: the last value wins, and the
  quantity box keeps showing it until its own answer comes back.

  Loaded after assets/cart.js (snippets/cart-drawer.liquid, sections/main-cart-items.liquid).
*/
(function () {
  'use strict';
  if (window.kkCart || typeof CartItems === 'undefined') return;

  var RENDER_FLAG = 'kk_render=1';
  var pending = new Map(); // a piece (data-group) -> the quantity tapped, shown until its answer arrives
  var chain = Promise.resolve();

  function queue(task) {
    var run = chain.then(task, task);
    chain = run.catch(function () {});
    return run;
  }

  function isGift(item) {
    return !!(item.properties && (item.properties._gift === 'true' || item.properties._gift === true));
  }

  function sameProperties(a, b) {
    return JSON.stringify(a.properties || {}) === JSON.stringify(b.properties || {});
  }

  function sectionIds() {
    var ids = [];
    var items = document.getElementById('main-cart-items');
    var foot = document.getElementById('main-cart-footer');
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (items && items.dataset.id) ids.push(items.dataset.id);
    if (foot && foot.dataset.id) ids.push(foot.dataset.id);
    ids.push('cart-live-region-text');
    return ids;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(
        function (json) { return { ok: res.ok, json: json }; },
        function () { return { ok: false, json: {} }; }
      );
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (res) {
      if (!res.ok) throw new Error('cart.js ' + res.status);
      return res.json();
    });
  }

  function parse(html) {
    return html ? new DOMParser().parseFromString(html, 'text/html') : null;
  }

  // ---- drawing -------------------------------------------------------------------------

  function renderDrawer(doc) {
    var cur = document.querySelector('#CartDrawer .drawer__inner');
    var next = doc && doc.querySelector('#CartDrawer .drawer__inner');
    if (!cur || !next) return;
    var scroller = cur.querySelector('cart-drawer-items');
    var scrollTop = scroller ? scroller.scrollTop : 0;
    cur.innerHTML = next.innerHTML;
    var nextScroller = cur.querySelector('cart-drawer-items');
    if (nextScroller) nextScroller.scrollTop = scrollTop;
    var wrap = cur.closest('cart-drawer');
    if (wrap) wrap.classList.toggle('is-empty', !!cur.querySelector('.drawer__inner-empty'));
  }

  function renderBubble(doc) {
    var cur = document.getElementById('cart-icon-bubble');
    var next = doc && doc.querySelector('.shopify-section');
    if (cur && next) cur.innerHTML = next.innerHTML;
  }

  // The cart page: its lines and count, its total, the rewards rail, Pairs well with and
  // the empty state.
  function renderPage(itemsDoc, footDoc) {
    var items = document.getElementById('main-cart-items');
    var foot = document.getElementById('main-cart-footer');
    [[items, itemsDoc], [foot, footDoc]].forEach(function (pair) {
      if (!pair[0] || !pair[1]) return;
      var next = pair[1].querySelector('#' + pair[0].id + ' .js-contents');
      var cur = pair[0].querySelector('.js-contents');
      if (next && cur) cur.innerHTML = next.innerHTML;
    });
    if (foot && footDoc) {
      var curRail = foot.querySelector('[data-kkp-rail]');
      var nextRail = footDoc.querySelector('[data-kkp-rail]');
      if (curRail && nextRail) curRail.innerHTML = nextRail.innerHTML;
      var curUp = foot.querySelector('[data-cr-upsell]');
      var nextUp = footDoc.querySelector('[data-cr-upsell]');
      if (curUp && nextUp) curUp.replaceWith(nextUp);
      else if (curUp) curUp.remove();
      else if (nextUp) {
        var box = foot.querySelector('.cart__footer');
        if (box) box.appendChild(nextUp);
      }
      var nextFoot = footDoc.getElementById('main-cart-footer');
      if (nextFoot) foot.classList.toggle('is-empty', nextFoot.classList.contains('is-empty'));
    }
    var wrap = items && items.closest('cart-items');
    var nextWrap = itemsDoc && itemsDoc.querySelector('cart-items');
    if (wrap && nextWrap) wrap.classList.toggle('is-empty', nextWrap.classList.contains('is-empty'));
  }

  // A tap still waiting for its answer keeps its number on screen through any re-draw.
  function showPending() {
    pending.forEach(function (qty, group) {
      rowsOf(group).forEach(function (row) {
        var input = row.querySelector('.quantity__input');
        if (input) input.value = qty;
      });
    });
  }

  function render(sections) {
    if (!sections) return;
    var items = document.getElementById('main-cart-items');
    var foot = document.getElementById('main-cart-footer');
    renderDrawer(parse(sections['cart-drawer']));
    renderBubble(parse(sections['cart-icon-bubble']));
    if (items && foot) {
      renderPage(parse(sections[items.dataset.id]), parse(sections[foot.dataset.id]));
    }
    showPending();
  }

  // Draw everything from the cart as it is now. A POST that changes nothing: a GET of
  // ?sections= can come back from Shopify's page cache, this cannot. redraw() runs at once
  // (for use inside a queued task); refresh() waits its turn.
  function redraw() {
    return postJSON('/cart/update.js?' + RENDER_FLAG, {
      updates: {},
      sections: sectionIds(),
      sections_url: window.location.pathname,
    }).then(function (res) {
      if (res.ok) render(res.json.sections);
      return res.json;
    });
  }

  function refresh() {
    return queue(redraw);
  }

  // ---- a quantity change ---------------------------------------------------------------

  function rowsOf(group) {
    return document.querySelectorAll('.kkl[data-group="' + group + '"]');
  }

  function showError(group, message) {
    var row = rowsOf(group)[0];
    var text = row && row.querySelector('.cart-item__error-text');
    if (text) {
      text.textContent = message;
      return;
    }
    var box = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (box) box.textContent = message;
  }

  // Dawn's: the live region speaks the new total for a moment.
  function announce(sections) {
    var status = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (!status) return;
    var doc = parse(sections && sections['cart-live-region-text']);
    var next = doc && doc.querySelector('.shopify-section');
    if (next) status.innerHTML = next.innerHTML;
    status.setAttribute('aria-hidden', 'false');
    setTimeout(function () { status.setAttribute('aria-hidden', 'true'); }, 1000);
  }

  // The updates that bring this piece's lines to `desired` in all: a rise goes on its last
  // line, a fall comes off its lines from the last one up.
  function planUpdates(cart, key, vid, desired) {
    var anchor =
      cart.items.find(function (i) { return i.key === key; }) ||
      cart.items.find(function (i) { return String(i.variant_id) === vid && !isGift(i); });
    if (!anchor) return {};
    var lines = cart.items.filter(function (i) {
      return i.variant_id === anchor.variant_id && !isGift(i) && sameProperties(i, anchor);
    });
    var total = lines.reduce(function (sum, i) { return sum + i.quantity; }, 0);
    var updates = {};
    if (desired > total) {
      var last = lines[lines.length - 1];
      updates[last.key] = last.quantity + (desired - total);
    } else {
      var cut = total - desired;
      for (var n = lines.length - 1; n >= 0 && cut > 0; n--) {
        var take = Math.min(cut, lines[n].quantity);
        updates[lines[n].key] = lines[n].quantity - take;
        cut -= take;
      }
    }
    return updates;
  }

  // After an answer, or after a failure: no spinner, and with no newer tap waiting the box
  // shows what the page was last drawn with.
  function settle(group) {
    rowsOf(group).forEach(function (row) {
      row.querySelectorAll('.loading__spinner').forEach(function (s) { s.classList.add('hidden'); });
      var input = row.querySelector('.quantity__input');
      if (input && !pending.has(group)) input.value = input.getAttribute('value');
    });
  }

  // A keyboard user keeps their place: the same control on the re-drawn line, else the
  // first line's name, else the empty cart's link.
  function restoreFocus(group, control) {
    if (!control || (document.activeElement && document.activeElement !== document.body)) return;
    var row = rowsOf(group)[0];
    var target =
      (row && control !== 'remove' && row.querySelector('[name="' + control + '"]')) ||
      document.querySelector('cart-drawer.active .kkl__name, #main-cart-items .kkl__name') ||
      document.querySelector('cart-drawer.active .drawer__inner-empty a, .cart__warnings a');
    if (!target) return;
    var drawer = target.closest('cart-drawer');
    if (drawer && typeof trapFocus === 'function') trapFocus(drawer, target);
    else target.focus({ preventScroll: true });
  }

  function commit(group, info) {
    if (!pending.has(group)) return Promise.resolve();
    var desired = pending.get(group); // the latest tap, read when its turn comes
    var done = function () { if (pending.get(group) === desired) pending.delete(group); };
    return getCart()
      .then(function (cart) {
        return postJSON('/cart/update.js', {
          updates: planUpdates(cart, info.key, info.vid, desired),
          sections: sectionIds(),
          sections_url: window.location.pathname,
        });
      })
      .then(function (res) {
        done();
        if (!res.ok) {
          var message = res.json.description || res.json.message || window.cartStrings.error;
          return redraw().then(function () { showError(group, message); });
        }
        render(res.json.sections);
        announce(res.json.sections);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: res.json, variantId: info.vid });
      })
      .catch(function (error) {
        console.error('[kk-cart] quantity change failed', error);
        done();
        return redraw().catch(function () {}).then(function () { showError(group, window.cartStrings.error); });
      })
      .then(function () {
        settle(group);
        restoreFocus(group, info.control);
      });
  }

  // A piece's new quantity. Each piece has its own short wait, so taps in a row go as one
  // change, and two pieces tapped together both go.
  var timers = new Map();
  function request(row, qty, wait, control) {
    var group = row.dataset.group;
    var info = { key: row.dataset.key, vid: row.dataset.variantId, control: control };
    pending.set(group, qty);
    showPending();
    rowsOf(group).forEach(function (r) {
      r.querySelectorAll('.loading__spinner').forEach(function (s) { s.classList.remove('hidden'); });
      var text = r.querySelector('.cart-item__error-text');
      if (text) text.textContent = '';
    });
    clearTimeout(timers.get(group));
    timers.set(group, setTimeout(function () {
      timers.delete(group);
      queue(function () { return commit(group, info); });
    }, wait));
  }

  // The quantity box — "+", "−" or a typed number — taken here instead of by Dawn's cart.js,
  // the moment it changes: a re-draw a moment later keeps the tapped number in the box, and
  // the next tap counts on from it.
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains('quantity__input')) return;
      var row = input.closest('.kkl');
      if (!row || !row.dataset.group) return;
      event.stopPropagation();
      var qty = parseInt(input.value, 10);
      var max = parseInt(input.max, 10);
      if (isNaN(qty) || qty < 0) {
        input.value = input.getAttribute('value');
        return;
      }
      if (!isNaN(max) && qty > max) qty = max;
      input.value = qty;
      var box = input.closest('quantity-input');
      if (box && box.validateQtyRules) box.validateQtyRules();
      var active = document.activeElement;
      var control = active && row.contains(active) ? active.getAttribute('name') : null;
      request(row, qty, typeof ON_CHANGE_DEBOUNCE_TIMER === 'number' ? ON_CHANGE_DEBOUNCE_TIMER : 300, control);
    },
    true
  );

  // Dawn's remove button (assets/cart.js) still calls this. `this` is the cart the tap
  // happened in — possibly one a re-draw has since detached — so the row is looked up
  // inside it, never by its position in the page.
  CartItems.prototype.updateQuantity = function (line, quantity) {
    var row = this.querySelector('#CartDrawer-Item-' + line) || this.querySelector('#CartItem-' + line);
    if (!row || !row.dataset.group) return;
    var active = document.activeElement;
    var control = active && row.contains(active) ? 'remove' : null;
    request(row, Math.max(0, parseInt(quantity, 10) || 0), 0, control);
  };

  window.kkCart = { queue: queue, refresh: refresh, render: render, sectionIds: sectionIds, RENDER_FLAG: RENDER_FLAG };
})();
